import { render, staticRenderFns } from "./ColorThemes.vue?vue&type=template&id=12810712&scoped=true&"
import script from "./ColorThemes.vue?vue&type=script&lang=js&"
export * from "./ColorThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12810712",
  null
  
)

export default component.exports